import { AVRProducts } from '../../utils/enums';

export default store => {
  store.subscribe(async (mutation, state) => {
    if (mutation.type === 'business/SET_INFO') {
      const mutationPayload = mutation.payload;
      const { products } = mutationPayload;

      // Has reviews??
      if (products.includes(AVRProducts.REVIEWS) && state.reviews.GMBReviewsIsEnabled) {
        await store.dispatch('reviews/getGMBReviewInfo');
      } else if (products.includes(AVRProducts.REVIEWS)) {
        await store.dispatch('reviews/getReviewInfo');
      }

      const isReviewsUser = products.indexOf(AVRProducts.REVIEWS) >= 0;
      if (isReviewsUser) {
        store.dispatch('reviews/fetchReviews');
      }
    }
  });
};
